import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { InventoryItem } from "../../models";
import { remove } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { deleteEntity } from "../../utils";

export const useDeleteInventoryItem = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("inventory-items", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Inventory Item Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.INVENTORY_ITEMS,
        (inventoryItems: InventoryItem[] | undefined) => {
          return !inventoryItems
            ? []
            : deleteEntity<InventoryItem>(inventoryItems, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Inventory Item Deleting Error", { variant: "error" });
    },
  });
};
